<template>
  <Modal
  v-model="isShow"
  :width="640"
  :loading="loading"
  :mask-closable="false"
  @on-ok="ok"
  >
    <h3 slot="header" class="modal-header">新增目标</h3>
    <Form
        class="modalbox"
        style="margin-top:24px"
        ref="searchData"
        :model="searchData"
        :rules="ruleValidate"
        :label-width="84">
      <Row>
         <Col span="20">
          <FormItem prop="projectFid" label="项目名称">
            <Select v-model="searchData.projectFid" placeholder="请选择" @on-change="getProjectName">
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in projectList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      
      <!-- 循环目标添加 -->
      <div v-for="(target, index) in searchData.targetList" :key="target.budgetItemName">
        <Row>
          <Col span="10">
            <FormItem prop="estimationType" label="目标类型">
              <Select v-model="target.estimationType" placeholder="请选择" @on-change="getConditionList($event, target)">
                <Option value=''>请选择</Option>
                <Option v-for="(item,index) in typeList"  v-show="typeListReaL.indexOf(item.value) == -1"  :key="'s1'+index" :value="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="10">
            <FormItem prop="targetAmount" label="目标值">
              <Input v-model="target.targetAmount" type="text" placeholder="请输入">
                <span slot="append" v-show="target.estimationType == 5">%</span>
              </Input>
            </FormItem>
          </Col>
          <Col span="4">
              <Button type="text" style="color:#CFA868;" v-if="index == 0" @click="addTarget">添加</Button>
              <Button type="text" style="color:#CFA868;" v-else @click="removeTarget(index)">删除</Button>
          </Col>
        </Row>
        <Row>
          <Col span="10">
            <FormItem prop="itemCode" label="费用项" >
              <Select v-model="target.itemCode" placeholder="请选择" @on-change="getBudgetCodeList($event,target)">
                <Option v-for="(item,index) in target.conditionList" :selected="target.conditionList.length == 1" :key="target.estimationType+item.value+index" :value="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="10">
            <FormItem prop="subjectCode" label="预算项">
              <Select v-model="target.subjectCode"  placeholder="请选择" @on-change="getSubjectName($event,target)">
                <Option v-for="(item,index) in target.budgetCodeList" :selected="target.budgetCodeList.length == 1" :key="item.budgetItemName+index" :value="item.budgetItemCode">{{item.budgetItemName}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </div>
      <!-- 循环目标添加 -->
      <Row>
        <Col span="10">
          <FormItem prop="incomeMethod" label="拆分方式">
            <Select v-model="searchData.incomeMethod" placeholder="请选择" >
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in chaifenList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="10">
           <FormItem prop="startMonth" label="起止日期">
            <Date-picker style="" v-model="searchData.startMonth" :options="startoptions" placeholder="请选择" type="month"></Date-picker>
            <!-- <Date-picker style="width:200px!important" v-model="searchData.endMonth" :options="endoptions" placeholder="请选择" split-panels type="month"></Date-picker> -->
          </FormItem>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>

<script>
import { saveTarget,condition,getBudgetCode } from 'api/targetApi'
import { formatDateTime, deepClone } from "../../../../utils/format";

export default {
  props:{
    n: {
      type: Number,
      default: 0
    },
    projectList:{
      type: Array,
      default(){
        return []
      }
    },
    typeList:{
      type:Array,
      default(){
        return []
      }
    },
    chaifenList:{
      type:Array,
      default(){
        return []
      }
    },
  },
  data(){
    const validates = (rule, value, callback) => {
      if (!value[0]) {
        callback(new Error('请选择起止日期'));
      } else{
        callback();
      }
    };
    const validates2 = (rule, value, callback) => {
      console.log(value)
      if (!value) {
        callback(new Error('请选择起止月份'));
      } else{
        callback();
      }
    };
    const money = (rule,value,callback) =>{
      let moneytest = /^(([0-9]|([1-9][0-9]{0,9}))((\.[0-9]{1,2})?))$/
      if(!moneytest.test(value)){
        callback(new Error('请输入正确的金额'));
      } else{
        callback();
      }
    };
    return{
      conditionList:[],
      // subjectCode:[],
      budgetCodeList:[],
      searchData:{
        projectFid:'',
        estimationType:'',

        itemCode:'',
        subjectCode:'',
        targetAmount:null,
        incomeMethod:null,

        timeArr:['',''],
        contractCode:'',
        supplierName:'',
        conditionList:[],
        startDate:'',
        endMonth: '',
        startMonth:'',
        
        targetList: [
          {
            itemCode:'',
            subjectCode:'',
            targetAmount:null,
            estimationType:'',
            conditionList: [],
            budgetCodeList: []
          }
        ]
        
      },
      isShow: false,
      loading:true,
      ruleValidate:{
        projectFid: [
          { required: true, message: '请选择项目名称', trigger: 'change',type:'string'}
        ],
        incomeMethod:[
          { required: true, message: '请选择拆方式', trigger: 'change', type:'number'}
        ],
        startMonth:[
          { required: true, message: '请选择起止日期', trigger: 'change', validator:validates2}
        ], 
        endMonth:[
          { required: true, message: '请选择起止日期', trigger: 'change', validator:validates2}
        ]
      }
    }
  },
  mounted() {
    // setInterval(() => {
    //   console.log(this.searchData.targetList)
    // },1000)
  },
  watch:{
    n(){
      this.$refs['searchData'].resetFields();
      this.searchData.startMonth = ''
      this.isShow = true
    }
  },
  computed:{
    typeListReaL(){
      let types = [];
      deepClone(this.searchData.targetList).map( target => {
        types.push(target.estimationType)
      })
      
      return types;
    },
    saveParams(){
      function f(data) {
        return data?formatDateTime(data, false):''
      }
      let year,month,GOPEndDate
      // if(this.searchData.estimationType >= 4){
      //    year = this.searchData.startMonth.getFullYear();
      //    month = this.searchData.startMonth.getMonth()+1;
      //    GOPEndDate = formatDateTime(new Date(year,month,0),false)
      // }
      return {
        projectFid: this.searchData.projectFid,   //项目id
        projectName: this.searchData.projectName, // 项目名称
        
        estimationType:this.searchData.estimationType, //目标类型
        targetAmount:this.searchData.targetAmount,  // 目标值

        itemCode:this.searchData.itemCode,   // 费用项Code
        itemName:this.searchData.itemName,   // 费用项Name
        subjectCode:this.searchData.subjectCode,  // 预算项Code
        subjectName:this.searchData.subjectName,  // 预算项Name
        incomeMethod:this.searchData.incomeMethod,  // 拆分方法
        startDate:f(this.searchData.startMonth),
        endDate:f(new Date(this.searchData.startMonth.setMonth(this.searchData.startMonth.getMonth()+1,0))),
        contractCode:this.searchData.contractCode,
        supplierName:this.searchData.supplierName,
        //新增字段
        goalItemDtoList: this.searchData.targetList.map(item => {
          let { estimationType, itemCode, itemName, subjectCode, subjectName, targetAmount } = item;

          return { estimationType, itemCode, itemName, subjectCode, subjectName, targetAmount };
        })
      }
    },
    startoptions(){
      let that = this;
      return {
        disabledDate(date){
          return that.searchData&&that.searchData.endMonth ? date.valueOf() > that.searchData.endMonth.valueOf() : false;
        }
      }
    },
    endoptions(){
      let that = this;
      return {
        disabledDate(date){
          return that.searchData&&that.searchData.startMonth ?  date.valueOf() < that.searchData.startMonth.valueOf()  : false;
        }
      }
    }
  },
  methods:{
    getProjectName(value){
      this.projectList.forEach( ele => {
        if(ele.value === value){
          this.searchData.projectName = ele.text
        }
      })
    },
    getBudgetCodeList(value,target){
      target.subjectCode=''
      if(!value){
        target.budgetCodeList = []
        return
      }
      target.conditionList.forEach(ele => {
        if(ele.value === value){
          target.itemName = ele.text
        }
      })
      getBudgetCode({
        busFeeCode:value
      })
      .then( res => {
        target.budgetCodeList = res.data;
        if(res.data.length == 1) {
          target.subjectCode = res.data[0].budgetItemCode
        }else {
          target.subjectCode = '';
        }
      })
    },
    getConditionList(value,target){
      if(!value){
        target.conditionList = []
        return
      }
      condition({
        type:value
      })
      .then( res => {
        target.conditionList = res.data;
        if (res.data.length == 1) {
          target.itemCode = res.data[0].value;
          this.getBudgetCodeList(res.data[0].value,target);
        } else {
          target.itemCode = '';
        }
      })
    },
    getSubjectName(value,target){
      target.budgetCodeList.forEach(ele => {
        if(ele.budgetItemCode === value){
          target.subjectName = ele.budgetItemName
        }
      })
    },
    changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
    ok(){
      this.$refs['searchData'].validate( bool => {
        if(bool){
          let params = {
            ...this.saveParams
          }
          saveTarget(params)
          .then( res => {
            if(res.code === 0){
              if(res.message && res.message != "success") {
                this.$Message.warning(res.message+' 类型已存在！')
              } else {
                this.$Message.success('保存成功');
              }
              setTimeout(() => {
                this.$emit('done')
              },1000);
            } else{
              this.$Message.error('保存失败')
            }
          })
          .catch( error => {
            this.$Message.error('保存失败')
          })
          .finally(()=>{
            this.isShow = false;
            this.clearTarget();
          })
        } else{
          this.changeLoading();
        }
      })
    },
    
    clearTarget() {
      this.$set(this.searchData, 'targetList', [{
        itemCode:'',
        itemName:'',
        subjectName:'',
        subjectCode:'',
        targetAmount:null,
        estimationType:'',
        conditionList: [],
        budgetCodeList: []
      }]);
    },

    addTarget(){
      this.searchData.targetList.push({
        itemCode:'',
        itemName:'',
        subjectName:'',
        subjectCode:'',
        targetAmount:null,
        estimationType:'',
        conditionList: [],
        budgetCodeList: []
      })
    },

    removeTarget(index){
      this.searchData.targetList.splice(index, 1);
    }

  }
}
</script>

<style>
  .modalbox .ivu-input-group-append{
    padding: 0;
  }
  .modalbox .ivu-input-group-append span{
    padding: 4px 7px;
  }
</style>
